// extracted by mini-css-extract-plugin
export default {"pinned-message":"PermissionNotifications__pinned-message__sSTfu","pinnedMessage":"PermissionNotifications__pinned-message__sSTfu"};